module.exports = __webpack_public_path__ + "img/ao.ao39110f8.svg";